import grapesjs from 'grapesjs';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('gjs-loading-page-container', (editor, opts = {}) => {
  const config = {
    blocks: [
      'loadingComponent',
    ],
    flexGrid: 0,
    stylePrefix: 'gjs-',
    addBasicStyle: true,
    name: 'loadingComponent',
    category: 'Básicos',
    labelComponent: 'Componente de Carga',
    ...opts,
  };
  loadBlocks(editor, config);
});
